if (!customElements.get('w101-co-creation')) {
  class W101CoCreation extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.sectionId = this.dataset.w101Section || '';
      this.stage = this.dataset.w101Stage || 'P5';
      this.initPtSlots();
      this.initInterestSignals();
      this.initRewardClaim();
      this.initIncomingAnchorContext();
      this.initExternalStateListeners();
    }

    initPtSlots() {
      this.querySelectorAll('[data-w101-pt-slot]').forEach((slot) => {
        const placement = slot.dataset.w101PtSlot || '';
        slot.dataset.w101PtReady = 'true';
        const detail = {
          sectionId: this.sectionId,
          stage: this.stage,
          placement,
          anchorId: placement === 'p5-purchase-intent' ? 'p5-survey' : placement,
          mountId: slot.id,
          initialValue: ''
        };
        this.dispatchEvent(new CustomEvent('w101:pt-slot-ready', { bubbles: true, detail }));
        if (slot.hasAttribute('data-w101-survey-slot')) {
          this.dispatchEvent(new CustomEvent('w101:survey-ready', {
            bubbles: true,
            detail: { ...detail, anchorId: 'p5-survey' }
          }));
        }
      });
    }

    initInterestSignals() {
      this.querySelectorAll('[data-w101-interest]').forEach((control) => {
        control.addEventListener('click', () => {
          control.dispatchEvent(new CustomEvent('w101:product-interest', {
            bubbles: true,
            detail: {
              sectionId: this.sectionId,
              stage: this.stage,
              placement: control.dataset.w101InterestPlacement || 'unknown',
              destination: control.getAttribute('href') || '',
              pagePath: window.location.pathname,
              pageUrl: window.location.href
            }
          }));
        });
      });
    }

    initRewardClaim() {
      this.querySelectorAll('[data-w101-reward-claim]').forEach((control) => {
        control.addEventListener('click', (event) => {
          if (control.getAttribute('aria-disabled') === 'true') {
            event.preventDefault();
            return;
          }
          const rewardPercent = Number(control.dataset.w101RewardPercent || 15);
          const destination = control.getAttribute('href') || '';
          const accepted = control.dispatchEvent(new CustomEvent('w101:reward-claim', {
            bubbles: true,
            cancelable: true,
            detail: {
              eventId: `p5-reward-${Date.now()}`,
              sectionId: this.sectionId,
              stage: this.stage,
              placement: control.dataset.w101RewardPlacement || 'p5-reward',
              rewardPercent,
              destination,
              pagePath: window.location.pathname,
              pageUrl: window.location.href
            }
          }));
          if (!destination || !accepted) event.preventDefault();
        });
      });
    }

    initIncomingAnchorContext() {
      const url = new URL(window.location.href);
      const hash = url.hash.replace('#', '');
      const source = url.searchParams.get('p5_source') || url.searchParams.get('p4_source') || url.searchParams.get('p3_source') || '';
      const entry = url.searchParams.get('p5_entry') || url.searchParams.get('p4_entry') || url.searchParams.get('p3_entry') || '';
      if (!hash && !source && !entry) return;
      const detail = { sectionId: this.sectionId, stage: this.stage, anchorId: hash, source, entry, pageUrl: window.location.href };
      this.dispatchEvent(new CustomEvent('w101:campaign-entry', { bubbles: true, detail }));
      if (url.searchParams.has('p5_source') || url.searchParams.has('p5_entry') || hash.startsWith('p5-')) {
        this.dispatchEvent(new CustomEvent('w101:p5-entry', { bubbles: true, detail }));
      }
      if (url.searchParams.has('p4_source') || url.searchParams.has('p4_entry') || hash.startsWith('p4-')) {
        this.dispatchEvent(new CustomEvent('w101:p4-entry', { bubbles: true, detail: { ...detail, entryStage: 'P4' } }));
      }
      if (url.searchParams.has('p3_source') || url.searchParams.has('p3_entry') || hash.startsWith('p3-')) {
        this.dispatchEvent(new CustomEvent('w101:p3-entry', { bubbles: true, detail: { ...detail, entryStage: 'P3' } }));
      }
    }

    initExternalStateListeners() {
      this.addEventListener('w101:reward-claim-saved', (event) => {
        const detail = event.detail || {};
        const rewardPercent = Number(detail.rewardPercent || 15);
        this.querySelectorAll('[data-w101-reward-status]').forEach((status) => {
          status.textContent = detail.message || `Your ${rewardPercent}% co-creator reward interest is recorded.`;
        });
        this.querySelectorAll('[data-w101-reward-claim]').forEach((control) => {
          control.setAttribute('aria-disabled', 'true');
          if (control.tagName === 'BUTTON') control.disabled = true;
        });
      });
      this.addEventListener('w101:reward-claim-failed', (event) => {
        const detail = event.detail || {};
        this.querySelectorAll('[data-w101-reward-status]').forEach((status) => {
          status.textContent = detail.message || 'We couldn’t save this yet. Please try again.';
        });
      });
    }
  }
  customElements.define('w101-co-creation', W101CoCreation);
}
